// extracted by mini-css-extract-plugin
export default {"container":"AdminConfigTractorNozzleProfiles_container__9BVY6"};